import React, { useEffect, useState } from "react";

/** Components */
import { Box, Button, ButtonGroup, Grid, TextField, Paper } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */

/** Api & Function */
import { checkWCF, createM23, getDriver, getInventory, getPO, replaceM23, getVehicle } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";
import moment from "moment";

/** Hook */
import { useLocation, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CreateM23 = () => {
  const [t] = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { ticketid } = useParams();
  const isReplace = Boolean(ticketid);
  const user = useSelector((state) => state.user.data);
  const [inputData, setInputData] = useState({
    bill_date: "",
    billNumber: "",
    billCert: "",
    vehicle: null,
    driver: null,
    po: null,
    billtemperature: "",
    billdensity15: "",
    billLTT: "",
    billvcf: "",
    billwcf: "",
    billKG: "",
    billL15: "",
    inventory: null,
    tank: null,
    billQty: "",
    note: "",
  });
  // eslint-disable-next-line no-unused-vars
  const [isDialogOpen, setDialogOpen] = useState(false);
  const data = {
    bill_date: inputData.bill_date,
    billNumber: inputData.billNumber,
    billCert: inputData.billCert,
    organization_id: user?.organization_id,
    pos_id: inputData.po?.id,
    origination: inputData.po?.origination,
    loadingtype_id: inputData.po?.loadingtype_id,
    provider_id: inputData.po?.provider_id,
    provider_name: inputData.po?.provider_name,
    product_id: inputData.po?.product_id,
    product_name: inputData.po?.product_name,
    currency: inputData.po?.currency,

    RSI: inputData.po?.id,
    billLTT: inputData.billLTT,
    billKg: inputData.billKG,
    billL15: inputData.billL15,

    lc_bank: inputData.po?.lc_bank,
    billUoM: inputData.po?.productunit_id,
    billQty: inputData.billQty,

    tank_id: inputData.tank?.id,
    tank_name: inputData.tank?.description,
    transagent_id: inputData.vehicle?.provider_id,
    vehicle_id: inputData.vehicle?.id,

    driver_id: inputData.driver?.id,

    billvcf: inputData.billvcf / 10000,
    billwcf: inputData.billwcf / 10000,
    billtemperature: inputData.billtemperature,
    billdensity15: inputData.billdensity15 / 10000,
    ext_vh_tanks: inputData.ext_vh_tanks,
    inventory_id: inputData.inventory?.id,
    inventory_name: inputData.inventory?.name,
    trx_date: moment(Date.now()).format("YYYY-MM-DD"),
    trans_resp: inputData.driver?.name,
    note: inputData.note,
    TransRoute: inputData.po?.route,
  };
  // method
  const handleSubmit = () => {
    if (isReplace) return replaceM23(ticketid, data);
    return createM23(data);
  };
  const handleSubmitResponse = (res) => {
    if (res.code === 200) history.push(`/m23/${res.data?.id}`);
  };
  const handleChangeTanks = (index, value) => {
    let newTanks = [...inputData.ext_vh_tanks];
    newTanks[index].lit = value;
    setInputData((prev) => ({ ...prev, ext_vh_tanks: newTanks }));
  };
  const handleChangeD15 = (e) => {
    setInputData((prev) => ({ ...prev, billdensity15: e.target.value, billwcf: "" }));
    if (!e.target.value) return;
    checkWCF({ d15: e.target.value / 10000 }).then((res) => {
      if (res.code !== 200) return;
      setInputData((prev) => ({ ...prev, billwcf: Math.round(res.data.wcf * 10000) }));
    });
  };
  useEffect(() => {
    if (!location.state) return;
    const receipt = location.state.receipt;
    setInputData((prev) => ({
      ...prev,
      ...receipt,
      bill_date: moment(receipt.bill_date).format("YYYY-MM-DD"),
      ext_vh_tanks: JSON.parse(receipt.ext_vh_tanks),
      billwcf: Math.round(receipt.billwcf * 10000),
      billvcf: Math.round(receipt.billvcf * 10000),
      billdensity15: Math.round(receipt.billdensity15 * 10000),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dispatch(setHeaderTitle("TẠO PHIẾU NHẬP MUA HÀNG NỘI ĐỊA"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Paper style={{ margin: 5, marginTop: 15 }}>
      <div style={{ width: "100%", gridGap: 20 }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <TextField fullWidth label={t("Số hóa đơn xuất")} value={inputData.billNumber} onChange={(e) => setInputData((prev) => ({ ...prev, billNumber: e.target.value }))} />
          </Grid>
          <Grid item xs={3}>
            <CustomDatePicker label={t("Ngày xuất hóa đơn")} value={inputData.bill_date} onChange={(value) => setInputData((prev) => ({ ...prev, bill_date: value }))} sx={{ width: "100%" }} />
          </Grid>
          <Grid item xs={3}>
            <FilterBy
              fullWidth
              label={t("Phương tiện")}
              getDataFunc={() => getVehicle({ status: 1, end_date: moment(Date.now()).format("YYYY-MM-DD"), groupvehicle_id: 455911 })}
              setDefaultFunc={(option) => location.state && setInputData((prev) => ({ ...prev, vehicle: option.find((item) => item.id === location.state.receipt.vehicle_id) }))}
              triggerSetDefaultFunc={location.state}
              value={inputData.vehicle}
              getOptionLabel={(option) => `${option.id} - ${option.license_plate}` || ""}
              filter={(option) => option.provider_id && JSON.parse(option.tanks)?.length}
              onChange={(e, newValue) =>
                setInputData((prev) => ({ ...prev, vehicle: newValue, driver: null, ext_vh_tanks: newValue && JSON.parse(newValue.tanks).map((item) => ({ ...item, lit: 0 })) }))
              }
            />
          </Grid>
          <Grid item xs={3}>
            <FilterBy
              fullWidth
              disabled={!inputData.vehicle}
              label={t("Người điều khiển")}
              getDataFunc={() => inputData.vehicle && getDriver({ provider_id: inputData.vehicle?.provider_id, status: 1 })}
              getDataDependencies={[inputData.vehicle]}
              filter={(option) => option.provider_id === inputData.vehicle?.provider_id}
              setDefaultFunc={(_, option) => location.state && setInputData((prev) => ({ ...prev, driver: option.find((item) => item.id === location.state.receipt.driver_id) || null }))}
              triggerSetDefaultFunc={location.state}
              value={inputData.driver}
              getOptionLabel={(option) => option.name || ""}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, driver: newValue }))}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label={t("Nhiệt độ")} value={inputData.billtemperature} onChange={(e) => setInputData((prev) => ({ ...prev, billtemperature: e.target.value }))} />
          </Grid>
          <Grid item xs={3}>
            <TextField
              error={(inputData.billdensity15 && inputData.billdensity15 < 7001) || inputData.billdensity15 > 8730}
              fullWidth
              label="D15"
              value={inputData.billdensity15}
              onChange={handleChangeD15}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              error={(inputData.billvcf && inputData.billvcf < 6900) || inputData.billvcf > 11000}
              fullWidth
              label="VCF"
              value={inputData.billvcf}
              onChange={(e) => setInputData((prev) => ({ ...prev, billvcf: e.target.value }))}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label="WCF" value={inputData.billwcf} onChange={(e) => setInputData((prev) => ({ ...prev, billwcf: e.target.value }))} />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label="Liter" value={inputData.billLTT} onChange={(e) => setInputData((prev) => ({ ...prev, billLTT: e.target.value }))} />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label="KG" value={inputData.billKG} onChange={(e) => setInputData((prev) => ({ ...prev, billKG: e.target.value }))} />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label="L15" value={inputData.billL15} onChange={(e) => setInputData((prev) => ({ ...prev, billL15: e.target.value }))} />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label={t("Bill/BLL")} value={inputData.billQty} onChange={(e) => setInputData((prev) => ({ ...prev, billQty: e.target.value }))} />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label={t("Chứng chỉ số")} value={inputData.billCert} onChange={(e) => setInputData((prev) => ({ ...prev, billCert: e.target.value }))} />
          </Grid>

          <Grid item xs={12} md={6}>
            {Boolean(inputData.ext_vh_tanks?.length) && (
              <Box sx={{ display: "flex", gridColumn: { md: "1 / 4", lg: "1 / 3", sm: "1 / 5", xs: "1 / 5" } }}>
                <div style={{ margin: "auto 0" }} align="left">
                  Khoảng cách tầm mức
                </div>
                <div style={{ display: "grid", width: "100%", gridTemplateColumns: `repeat(${inputData.ext_vh_tanks.length}, 1fr)`, gridColumnGap: 20 }}>
                  {inputData.ext_vh_tanks.map((item, index) => (
                    <TextField key={index} label={item.code} value={item.lit} onChange={(e) => handleChangeTanks(index, e.target.value)} />
                  ))}
                </div>
              </Box>
            )}
          </Grid>
        </Grid>
      </div>
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", margin: "20px 0", textTransform: "uppercase" }}>{t("Thông tin nhập hàng tại kho")}</div>
      <Grid container spacing={2}>
        <Grid item xs={6} md={6} lg={3}>
          <FilterBy
            getDataFunc={() => getInventory({ status: 1 })}
            value={inputData.inventory}
            setDefaultFunc={(_, option) => setInputData((prev) => ({ ...prev, inventory: option.find((item) => item.id === location.state?.receipt?.inventory_id) }))}
            triggerSetDefaultFunc={location.state}
            label={t("Kho nhập")}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, inventory: newValue }))}
            disabled={Boolean(inputData.ltp)}
          />
        </Grid>
        <Grid item xs={6} md={6} lg={3}>
          <FilterBy
            value={inputData.tank || null}
            label={t("Bể")}
            disableClearable
            getDataFunc={() => Promise.resolve({ data: inputData.inventory?.tanks || [], code: 200 })}
            getDataDependencies={[inputData.inventory]}
            getOptionLabel={(option) => `${option.code} - ${option.description}` || ""}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, tank: option.find((item) => item.id === location.state?.receipt?.tank_id) }))}
            triggerSetDefaultFunc={location.state}
            style={{ minWidth: "150px" }}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, tank: newValue }))}
          />
        </Grid>
        <Grid item xs={6} md={6} lg={3}>
          <FilterBy
            fullWidth
            label={t("Đơn mua hàng quốc nội")}
            getDataFunc={() => getPO({ status: 1, loadingtype_id: 3 })}
            value={inputData.po}
            getOptionLabel={(option) => `${option.id} - ${option.trx_number} (${option.product_name}) -- ${option.route}` || ""}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, po: option.find((item) => item.id === location.state?.receipt?.pos_id) }))}
            triggerSetDefaultFunc={location.state}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, po: newValue }))}
          />
        </Grid>
        <Grid item xs={6} md={6} lg={3}>
          <TextField fullWidth label={t("Ghi chú")} value={inputData.note} onChange={(e) => setInputData((prev) => ({ ...prev, note: e.target.value }))} />
        </Grid>
      </Grid>
      <div align="left">
        {/* button is disabled if required field is empty */}
        <ButtonGroup style={{ marginTop: 10 }}>
          <Button variant="contained" onClick={() => setDialogOpen(true)} color="info">
            {t("Xem trước")}
          </Button>
          <ButtonWithAPICall variant="contained" api={handleSubmit} response={handleSubmitResponse}>
            {t(isReplace ? "Phát hành thay thế" : "Tạo phiếu")}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
    </Paper>
  );
};
export default CreateM23;
